import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ViewWithSeparators } from 'components/ViewWithSeparators';
import { smartText } from 'lib/str';
import React from 'react';

type Props = {
  label: string;
  explanation?: string;
  enableTasks: boolean;
  enableTaskDueDate: boolean;
  enableTaskSeverity: boolean;
  enableTaskTimescale: boolean;
  enableTaskCategory: boolean;
  enableTaskPhotos: boolean;
  onChange: (
    key:
      | 'enableTasks'
      | 'enableTaskDueDate'
      | 'enableTaskSeverity'
      | 'enableTaskTimescale'
      | 'enableTaskCategory'
      | 'enableTaskPhotos',
    value: boolean,
  ) => void;
};

export const EngageSettingsActions: React.FC<Props> = ({
  label,
  explanation,
  onChange,
  enableTasks,
  enableTaskCategory,
  enableTaskDueDate,
  enableTaskPhotos,
  enableTaskSeverity,
  enableTaskTimescale,
}) => (
  <>
    <Card label={label} marginBottomQuarter>
      <CardRow
        label={`Show ${label}`}
        checkedValue={enableTasks}
        onPress={() => onChange('enableTasks', !enableTasks)}
      />
    </Card>
    <Card explanation={explanation ? smartText(explanation) : undefined}>
      <ViewWithSeparators horizontal>
        <CardRow
          label="Show Due Date"
          checkedValue={enableTaskDueDate}
          onPress={() => onChange('enableTaskDueDate', !enableTaskDueDate)}
          style={{ flex: 1 }}
        />
      </ViewWithSeparators>
      <ViewWithSeparators horizontal>
        <CardRow
          label="Show Timescale"
          checkedValue={enableTaskTimescale}
          onPress={() => onChange('enableTaskTimescale', !enableTaskTimescale)}
          style={{ flex: 1 }}
        />
        <CardRow
          label="Show Severities"
          checkedValue={enableTaskSeverity}
          onPress={() => onChange('enableTaskSeverity', !enableTaskSeverity)}
          style={{ flex: 1 }}
        />
      </ViewWithSeparators>
      <ViewWithSeparators horizontal>
        <CardRow
          label="Show Categories"
          checkedValue={enableTaskCategory}
          onPress={() => onChange('enableTaskCategory', !enableTaskCategory)}
          style={{ flex: 1 }}
        />
        <CardRow
          label="Show Photos"
          checkedValue={enableTaskPhotos}
          onPress={() => onChange('enableTaskPhotos', !enableTaskPhotos)}
          style={{ flex: 1 }}
        />
      </ViewWithSeparators>
    </Card>
  </>
);
